<section class="nav-item">
  <!-- profile icon  -->
  <button
    class="nav-icon"
    mat-icon-button
    [matMenuTriggerFor]="profile"
    aria-label="Example icon-button with a menu"
  >
    <morva-icons data-testid="home-profile-icon" icon="person" nbTooltip="حساب کاربری" nbTooltipPlacement="bottom"></morva-icons>
  </button>
  <!-- profile dropdown -->
  <mat-menu #profile="matMenu" class="profile-card">
    <nb-card [size]="'medium'" *ngIf="user">
      <nb-card-body>
        <nb-list>
          <nb-list-item class="d-flex align-items-center">
            <div>
              <img [src]="user.avatarPath !== null ? avatarPath : 'assets/images/userAvatar.png'" class="rounded-circle ms-2" />
            </div>
            <div>
              <p class="p-1st">{{ user.firstName + ' ' + user.lastName }}</p>
            </div>
          </nb-list-item>
          <nb-list-item>
            <div class="mt-3">
              <p *ngIf="activeWorkspaceId && responsiveMode === 'xl'" class="p-3rd" data-testid="user-management-button" (click)="navigateToProfilePage()">
                مدیریت حساب کاربری
              </p>
              <p class="p-3rd" data-testid="user-logout-button" (click)="logOutUser()">
                خروج
              </p>
            </div>
            <div></div>
          </nb-list-item>
        </nb-list>
      </nb-card-body>
    </nb-card>
  </mat-menu>
</section>
